const COMP_PRE = 'v';
const CLS_PRE = 'v';

export function useConfig() {
  return { COMP_PRE, CLS_PRE };
}
